<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>平台数据</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-row :gutter="20">
      <el-col :span="6">
        <div class="dis_jcsb box-cell box-cell-bg1 mar_B_20">
          <div class="box-icon box-icon-bg1">
            <svg class="custom-icon" aria-hidden="true">
              <use xlink:href="#custom-icon-shebei" />
            </svg>
          </div>
          <div class="box-title">
            <div class="online">在线设备</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="dev_online" :duration="185"></count-to>
            </span>
            <span class="nums">+ 0.54%</span>
          </div>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="dis_jcsb box-cell box-cell-bg2 mar_B_20">
          <div class="box-icon box-icon-bg2">
            <svg class="custom-icon" aria-hidden="true">
              <use xlink:href="#custom-icon-wode3" />
            </svg>
          </div>
          <div class="box-title">
            <div class="online">在线用户</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="user_online" :duration="295"></count-to>
            </span>
            <span class="nums">+ 4.7%</span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="dis_jcsb box-cell box-cell-bg3 mar_B_20">
          <div class="box-icon box-icon-bg3">
            <svg class="custom-icon" aria-hidden="true">
              <use xlink:href="#custom-icon-shebei" />
            </svg>
          </div>
          <div class="box-title">
            <div class="online">离线设备</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="dev_line" :duration="256"></count-to>
            </span>
            <span class="nums">+ 0.4%</span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="dis_jcsb box-cell box-cell-bg4 mar_B_20">
          <div class="box-icon box-icon-bg4">
            <svg class="custom-icon" aria-hidden="true">
              <use xlink:href="#custom-icon-fangche" />
            </svg>
          </div>
          <div class="box-title">
            <div class="online">当前运动中</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="dev_run" :duration="150"></count-to>
            </span>
            <span class="nums">+ 1.4%</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <div v-loading="loading.loading">
      <el-row class="mt10">
        <el-col :span="18" class="pr5 mb10">
          <el-card>
            <div slot="header" class="clearfix flex space">
              <span class="col45">最近一周活跃设备</span>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-button-group>
                  <el-button size="mini" :autofocus="true" @click="getIndexActive(1)">本周</el-button>
                  <el-button size="mini" @click="getIndexActive(2)">本月</el-button>
                  <el-button size="mini" @click="getIndexActive(3)">本年</el-button>
                </el-button-group>
              </div>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-date-picker
                  :pickerOptions="pickerOptions"
                  @input="getDateBill"
                  v-model="billDate"
                  size="mini"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
            </div>
            <div id="line" style="width: 100%; height: 400px"></div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>设备统计</span>
            </div>
            <div id="pie" style="width: 300px; height: 300px;"></div>
          </el-card>
          <div class="dev_line">
            <div class="li">
              <div class="title">今天</div>
              <div class="nums">{{dev_online_day}}台</div>
            </div>
            <div class="li">
              <div class="title">本月</div>
              <div class="nums">{{dev_online_month}}台</div>
            </div>
            <div class="li">
              <div class="title">本年</div>
              <div class="nums">{{dev_online_years}}台</div>
            </div>
          </div>
        </el-col>
      </el-row>
      
      <el-row class="mt10">
        <el-col :span="18" class="pr5 mb10">
          <el-card>
            <div slot="header" class="clearfix flex space">
              <span class="col2">设备型号占比</span>
            </div>
            <div class="flex" style="width: 100%; min-height: 300px">
              <div class="col4 text-center" v-for="item in devtype" :key="item.id">
                <div class="mb20">{{item.line}}路</div>
                <el-progress type="circle" :percentage="item.rang" :stroke-width="15"></el-progress>
                <div class="mt20">
                  <span class="font30">{{item.count}}</span>
                  台
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>设备时长</span>
            </div>
            <div id="bar" style="width: 100%; height: 300px"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import countTo from "vue-count-to";
export default {
  components: { countTo },
  data() {
    return {
      dev_online: 0,
      dev_line: 0,
      user_online: 0,
      dev_run: 0,
      devtype: [],
      billDate: [],
      loading: {
        loading: true,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      active_dev: "",
      online_dev: "",
      times_dev: "",
      online_days: "",
      online_series1: "",
      online_series2: "",
      dev_online_day: 0,
      dev_online_month: 0,
      dev_online_years: 0,
    };
  },
  created() {
    this.getIndex();
    this.getIndexActive();
    this.loading.loading = false;
  },
  mounted() {
    //this.drawChart();
  },
  methods: {
    getDateBill() {
      console.log(this.billDate);
      this.getIndexActive();
    },
    getIndex() {
      const that = this;
      that.axios.post("/index/data").then((res) => {
        console.log(res);
        if (res.code == 200) {
          console.log(res.data.devtype);
          this.dev_online = res.data.dev_online;
          this.dev_line = res.data.dev_line;
          this.user_online = res.data.user_online;
          this.dev_run = res.data.dev_run;
          this.devtype = res.data.devtype;
          this.dev_online_day = res.data.dev_online_day;
          this.dev_online_month = res.data.dev_online_month;
          this.dev_online_years = res.data.dev_online_years;
          this.online_days = res.data.online.days;
          this.online_series1 = res.data.online.series1;
          this.online_series2 = res.data.online.series2;
          this.loading.loading = false;
          this.drawChart();
          this.drawChart2();
        } else {
          this.loading.loading = false;
          that.$message.error(res.msg);
        }
      });
    },

    //获取活动日志get_index_active_users
    getIndexActive(type) {
      const that = this;
      that.axios
        .post("/get_index_active_users", {
          type: type,
          times: this.billDate,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.active_dev = res.data.data;
            this.online_dev = res.data.data1;
            this.times_dev = res.data.date;
            this.drawChart1();
            this.loading.loading = false;
          } else {
            this.loading.loading = false;
            that.$message.error(res.msg);
          }
        });
    },

    drawChart() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("bar"));
      // 指定图表的配置项和数据
      let option = {
        xAxis: {
          data: this.online_days,
        },
        yAxis: {},
        color: ["#b2f549", "#b1b1b1"],
        series: [
          {
            name: "在线",
            type: "bar",
            data: this.online_series1,
          },
          {
            name: "离线",
            type: "bar",
            data: this.online_series2,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    drawChart1() {
      console.log(this.times_dev);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("line"));
      // 指定图表的配置项和数据
      let option = {
        tooltip: {},
        color: ["#3998fc", "#b2f549"],
        legend: {
          data: ["在线", "活跃"],
        },
        xAxis: {
          data: this.times_dev,
        },
        yAxis: {},
        series: [
          {
            name: "在线",
            type: "line",
            data: this.online_dev,
            smooth: true,
          },
          {
            name: "活跃",
            type: "line",
            data: this.active_dev,
            smooth: true,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    drawChart2() {
      let myChart = this.$echarts.init(document.getElementById("pie"));

      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        color: ["#409eff", "#f59a23"],
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: [
              { value: this.dev_online, name: "在线" },
              { value: this.dev_line, name: "离线" },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },
  },
};
</script>

<style>
.el-card__header {
  line-height: 30px;
}

.box-cell-bg1 {
  background: url(/images/u122.png) no-repeat center 110px;
  background-size: 90%;
}

.box-cell-bg2 {
  background: url(/images/u134.png) no-repeat center 110px;
  background-size: 90%;
}

.box-cell-bg3 {
  background: url(/images/u146.png) no-repeat center 110px;
  background-size: 90%;
}

.box-cell-bg4 {
  background: url(/images/u158.png) no-repeat center 110px;
  background-size: 90%;
}

.box-cell {
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
  height: 171px;
  padding: 10px 20px 20px 20px;
  background-color: #fff;
  border-radius: 15px;
}

.box-cell .box-icon {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 30px;
}

.box-cell .box-icon-bg1 {
  background-color: #5ad8a6;
}

.box-cell .box-icon-bg2 {
  background-color: #81d3f8;
}

.box-cell .box-icon-bg3 {
  background-color: #c280ff;
}

.box-cell .box-icon-bg4 {
  background-color: #ffa94c;
}

.box-cell .box-title {
  display: flex;
  flex-direction: column;
  width: 54%;
}

.box-cell .box-title .online {
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}

.box-cell .box-title .yestaday {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.box-cell .box-nums {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.box-cell .box-nums .total {
  line-height: 30px;
  font-size: 30px;
}

.box-cell .box-nums .nums {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.gl-count {
  flex: 1;
  text-align: center;
}

.gl-count p:nth-child(1) {
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 16px;
  color: #666;
}

.gl-count p:nth-child(2) {
  font-size: 38px;
  line-height: 35px;
  color: #1676eb;
  font-weight: bold;
}

.gl-count p:nth-child(2):after {
  box-sizing: border-box;
}
.el-card__body {
  display: flex;
  justify-content: center;
}

.dev_line {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 23px 20px;
}

.dev_line .li {
  width: 33.3%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dev_line .li .title {
  font-size: 14px;
  color: #666;
  line-height: 27px;
}

.dev_line .li .nums {
  font-size: 14px;
  color: #666;
  line-height: 27px;
}
</style>
